<template>
  <div class="my-4 mx-4">
    <div class="bg-white overflow-hidden shadow rounded-lg">
      <div
        class="border-b border-gray-200 px-4 py-3 sm:px-6 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
      >
        <!-- Content goes here -->
        <!-- We use less vertical padding on card headers on desktop than on body sections -->

        Choose color
      </div>
      <div class="px-4 py-5 sm:p-6">
        <PalettePicker @colorSelected="onColorSelected" />
      </div>
    </div>
  </div>
</template>

<script>
import PalettePicker from "./PalettePicker";

export default {
  components: {
    PalettePicker,
  },
  data() {
    return {};
  },
  methods: {
    onColorSelected(color) {
      this.$store.dispatch("updateColor", color);
    },
  },
};
</script>

<style lang="scss" scoped></style>
